import PropTypes from 'prop-types';
import React from 'react';

import BrMultistateToggle from '@components/BrMultistateToggle';

export default function MultistateToggleColumn({ row, col, cell }) {
  return (
    <div className="multi-toggle-column-cell">
      <BrMultistateToggle
        states={col.columnConfig.states}
        selectedValue={cell.value}
        onClick={(val) => col.columnConfig.onClick(row, val)}
      />
    </div>
  );
}

MultistateToggleColumn.propTypes = {
  row: PropTypes.object.isRequired, // row data
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      onClick: PropTypes.func.isRequired, // (row, value) :=> {}
      states: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          value: PropTypes.any.isRequired,
          tooltip: PropTypes.any,
        }),
      ).isRequired,
    }).isRequired,
  }).isRequired,
  cell: PropTypes.shape({
    value: PropTypes.any,
  }).isRequired,
};
